module.exports = __webpack_public_path__ + "img/Exploring_Sorting_Algorithms_in_JavaScript.ff8b5e92.jpeg";